import { c as _c } from "react/compiler-runtime";
import type * as React from "react";
import { cn } from "../shared/cn";
import { ExternalLink } from "../shared/external-link";
import { ClickableCode } from "./clickable-code";
function Keyword(t0) {
  const $ = _c(3);
  const {
    children,
    onClick
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== onClick) {
    t1 = <ClickableCode className="inline-block" onClick={onClick}>{children}</ClickableCode>;
    $[0] = children;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
type KeywordInfo = {
  keywords: string[];
  info: React.ReactNode;
};
export function AvailableDestinations(t0) {
  const $ = _c(11);
  const {
    selectedDestination,
    onSelectedDestinationChange
  } = t0;
  let t1;
  if ($[0] !== onSelectedDestinationChange) {
    t1 = function handleKeywordClick(t2) {
      const {
        currentTarget
      } = t2;
      onSelectedDestinationChange(currentTarget.textContent);
    };
    $[0] = onSelectedDestinationChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleKeywordClick = t1;
  let t2;
  if ($[2] !== handleKeywordClick || $[3] !== selectedDestination) {
    const keywordInfos = [{
      keywords: ["b"],
      info: <>package cost estimation on{" "}<ExternalLink href="https://bundlephobia.com" /></>
    }, {
      keywords: ["c"],
      info: "changelog"
    }, {
      keywords: ["g"],
      info: <>github (gitlab, etc.) repository root</>
    }, {
      keywords: ["h", "w", "d"],
      info: <>homepage (aliased as <Keyword onClick={handleKeywordClick}>w</Keyword>{" "}for website or <Keyword onClick={handleKeywordClick}>d</Keyword>{" "}for docs)</>
    }, {
      keywords: ["i"],
      info: <>issues</>
    }, {
      keywords: ["n"],
      info: <>package info on <ExternalLink href="https://www.npmjs.com" /></>
    }, {
      keywords: ["p", "m"],
      info: <>pull requests (aliased as{" "}<Keyword onClick={handleKeywordClick}>m</Keyword> for merge requests)</>
    }, {
      keywords: ["r"],
      info: "list of github releases"
    }, {
      keywords: ["s"],
      info: <>source (often same as repository root, but can be its subdirectory in case of a monorepo)</>
    }, {
      keywords: ["t"],
      info: "list of git tags"
    }, {
      keywords: ["u"],
      info: <>package contents preview on <ExternalLink href="https://unpkg.com" /></>
    }, {
      keywords: ["v"],
      info: <>list of package versions with dates on{" "}<ExternalLink href="https://www.npmjs.com" /></>
    }, {
      keywords: ["x"],
      info: <>package page on <ExternalLink href="https://npmx.dev" /></>
    }, {
      keywords: ["y"],
      info: <>package page on <ExternalLink href="https://yarnpkg.com" /></>
    }, {
      keywords: ["."],
      info: <>browse GitHub / GitLab code</>
    }];
    t2 = <ul className="overflow-hidden">{keywordInfos.map(t3 => {
        const {
          keywords,
          info
        } = t3;
        return <li key={keywords.join(",")} className={cn("whitespace-nowrap", selectedDestination && keywords.includes(selectedDestination) && "text-primary")}><Keyword onClick={handleKeywordClick}>{keywords[0] ?? ""}</Keyword>{" "}<span className="mr-10 ml-1 inline-block align-top whitespace-normal">{info}</span></li>;
      })}</ul>;
    $[2] = handleKeywordClick;
    $[3] = selectedDestination;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ExternalLink href="https://www.npmjs.com" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleKeywordClick) {
    t4 = <p>Omitting the destination or entering an non-existing one takes you to the package page on {t3} as if you used <Keyword onClick={handleKeywordClick}>n</Keyword>.</p>;
    $[6] = handleKeywordClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}